export default __webpack_public_path__ + "static/media/federico-beccari.11b11965.jpg";